import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
// Icon font bundled with the app (no CDN): icons and icon-only buttons work on networks that block jsdelivr
import 'remixicon/fonts/remixicon.css'
import './index.css'
import App from './App.tsx'

// The theme chosen on the chat page applies to every page (admin, login, landing ...),
// also when one of them is opened directly or reloaded
try {
  document.documentElement.classList.toggle('dark', localStorage.getItem('darkMode') === 'true')
} catch { /* storage unavailable: light theme */ }

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
